(function () {
    if (window.__productVideoHydrate) return;
    window.__productVideoHydrate = true;

    function hydrate(video) {
      if (!video || video.dataset.videoReady === '1') return;
      video.dataset.videoReady = '1';
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
      });
      video.load();
    }

    function playFromButton(btn) {
      var shell = btn.closest('.product-media__video-shell');
      var video = shell && shell.querySelector('video[data-product-video]');
      if (!video) return;
      hydrate(video);
      shell.classList.add('is-playing');
      var play = video.play();
      if (play && typeof play.catch === 'function') play.catch(function () {});
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-product-video-play]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        playFromButton(btn);
        return;
      }
      var video = e.target && e.target.closest && e.target.closest('video[data-product-video]');
      if (video && video.dataset.videoReady !== '1') {
        hydrate(video);
        var shell = video.closest('.product-media__video-shell');
        if (shell) shell.classList.add('is-playing');
        var play = video.play();
        if (play && typeof play.catch === 'function') play.catch(function () {});
      }
    }, true);
  })();